var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-aside-container"},[(_vm.data)?[_c('Avatar',{attrs:{"url":_vm.data.avatar,"size":150}}),_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.data.siteTitle))]),_c('Menu'),_c('Contact'),_c('p',{staticClass:"footer"},[_vm._v(_vm._s(_vm.data.record))])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }